module.exports = __webpack_public_path__ + "img/phone_white.33d1cd1f.svg";